import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { updateSelectedShoppingList } from '../../api/backend';
import { Application } from '../../core/app';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 400,
  width: '80%',
  bgcolor: 'var(--surface-bg)',
  border: '1px solid var(--wire-green)',
  borderRadius: 12,
  boxShadow: 'inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 8px 32px rgba(0, 0, 0, 0.4)',
  p: 4,
};


export default function BasicModal(props) {

  let { selected, lists, getItemList, handleAddButtonClick, setInputValue, inputValue, handleListDelete } = props;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleClick = (list) => {
    
    updateSelectedShoppingList(list.id).then(res => {
    });
    Application.setSelectedShoppingList(list.id);
    getItemList(list.id);

    handleClose();
  }

  const deleteList = (list) => {
    handleListDelete(list);
  }

  


  return (
    <div>
      <Button onClick={handleOpen}>Select Shopping List</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <div className='add-item-box'>
          <input value={inputValue} onChange={(event) => setInputValue(event.target.value)} className='add-item-input' placeholder='Add a list...' />
          <FontAwesomeIcon icon={faPlus} onClick={() => handleAddButtonClick()} />
        </div>
        <div className='item-div'>
          {lists ? lists.map((list, index) => (
              <div key={index} className='item-container'>
                <div className='list-name' onClick={() => handleClick(list)}>
                  <span>{list.name}</span>
                </div>
                <div className='amount'>
                    <span> {list.shopping_list_items_count} </span>
                </div>
                <div className='delete'>
                  <button className='delete-color'>
                      <FontAwesomeIcon icon={faTrash} onClick={() => deleteList(list)} />
                  </button>
                </div>
              </div>
            )) : ''}
          </div>
        </Box>
      </Modal>
    </div>
  );
}